import React, { useCallback, useMemo, useRef, useState, useLayoutEffect, useEffect } from "react";
import { Formik, Form, ErrorMessage, useField, useFormikContext } from "formik";
import * as Yup from "yup";
import styles from "./commentBoxWithAttachment.module.css";
import IMAGES from "../../assets/images/images";
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel } from "../../components/label/Labels";
import FileUploadAttachment from "./fileAttachment/fileAttachment.container";
import { Loader } from "../loader/Loader";


const ImageUpload = ({
  setFieldValue,
  value,
  label,
  isUploadReport = false,
  SetError,
  shoInlineError,
  data,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  return (
    <div>
      <FileUploadAttachment
        setFieldValue={setFieldValue}
        SetError={SetError || (() => { })}
        isUploadReport={isUploadReport}
        shoInlineError={shoInlineError}
        name={props.name}
        value={value}
        displayMessage={"Upload limit: 3 files, up to 5 MB."}
        maxFileSize={5 * 1024 * 1024} //5MB
        maxFileSizeTXT={"5MB"}
        combineFilesMaxSize={5 * 1024 * 1024}
        combineFilesMaxSizeTXT={"Combined file size exceeds the 5MB limit"}
        numOfFilesAllowToUpload={3}
        errorMessageForNumberOfFiles={"You can upload a maximum of 3 files."}
        acceptFileType={{
        'image/*': ['.jpeg','.png',],
        'application/pdf': ['.pdf'],
        'application/vnd.ms-excel': ['.xls',],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':['.xlsx'],
        'application/msword':['.doc'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']
        }}
      />
      {/* {hasError ? <ErrorLabel text={meta.error} /> : null} */}
    </div>
  );
};

const CommentBoxWithAttachment = ({ isSubmit, sendDisabled }) => {
  const [isError, setisError] = useState("");
  const textareaRef = useRef(null);
  const [{ value: message }, meta, helpers] = useField("message");
  const { values, setFieldValue } = useFormikContext();
  const [isMultiline, setIsMultiline] = useState(false);
  const SetError = (error) => {
    setisError(error)
  }
  const LINE_HEIGHT = 16;
  const MAX_LINES = 5;

  const syncHeightsAndMode = useCallback(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    const cs = window.getComputedStyle(el);
    const lineHeight = parseFloat(cs.lineHeight) || LINE_HEIGHT;
    const paddingTop = parseFloat(cs.paddingTop) || 0;
    const paddingBottom = parseFloat(cs.paddingBottom) || 0;
    const oneLine = lineHeight + paddingTop + paddingBottom;
    const maxPx = lineHeight * MAX_LINES + paddingTop + paddingBottom;
    const nextHeight = Math.min(el.scrollHeight, maxPx);
    el.style.height = `${nextHeight}px`;
    const heightIndicatesMultiline = el.scrollHeight > oneLine + 1;
    const hasFiles =
      Array.isArray(values?.files) ? values.files.length > 0 : Boolean(values?.files);
    setIsMultiline(hasFiles || heightIndicatesMultiline);
  }, [values?.files, LINE_HEIGHT, MAX_LINES]);

  useLayoutEffect(() => {
    syncHeightsAndMode();
  }, [message, syncHeightsAndMode]);

  useEffect(() => {
    syncHeightsAndMode();
  }, [values?.files, syncHeightsAndMode]);

  const onInput = useCallback(
    (e) => {
      helpers.setValue(e.target.value);
      syncHeightsAndMode();
    },
    [helpers, syncHeightsAndMode]
  );

  return (
    <div className={styles.section}>
      <div className={styles.composer}>
        <div className={styles.composerInner}>
          <textarea
            ref={textareaRef}
            maxLength={1000}
            name="message"
            rows={1}
            aria-label="Message"
            placeholder="Type a message"
            onBlur={() => helpers.setTouched(true)}
            className={`${styles.composerTextarea} ${isMultiline ? styles.textareaMultiline : ""}`}
            value={message}
            onChange={onInput}
          />
          <div className={`${isMultiline ? styles.composerBar : styles.overlayActions}`}>
            <ImageUpload
              name="files"
              value={values.files}
              setFieldValue={setFieldValue}
              optional={false}
              shoInlineError={false}
              SetError={SetError}
            />
            <button type="submit" className={styles.sendBtn} >
              {isSubmit ?<Loader loaderStyle={styles.uploadLoader}/>:
              <img
                className={`${styles.iconBtn}`}
                src={IMAGES.send} alt="icon" />}
            </button>
          </div>
        </div>
      </div>
      <div className={styles.error}>
        <div>
          {meta.touched && meta.error && <ErrorLabel text={meta.error} />}
          {isError && <div className={styles.fileSizeErrormsg}>{isError}</div>}
        </div>
        <div className={styles.filelimit}><span className={styles.charlimit}>{`${values?.message?.length}/1000 characters`}</span>Upload limit: 3 files, up to 5 MB.</div>
      </div>
    </div>
  );
}

export default CommentBoxWithAttachment;